import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

export default function BookTabsMode({
  bookTab,
  handleBookTabChange,
  searchContent,
  manualContent,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: { xs: 2, md: 3 },
      }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={bookTab}
          onChange={handleBookTabChange}
          aria-label="citation tabs ">
          <Tab
            value="search"
            label="Search Books"
            id="search-books"
            aria-controls="search-books"
          />{" "}
          <Tab
            value="manual"
            label="Manual"
            id="manual"
            aria-controls="manual"
          />{" "}
        </Tabs>
      </Box>
      {bookTab === "search"
        ? searchContent && searchContent
        : manualContent && manualContent}
    </Box>
  );
}
